
import { defineComponent, inject, ref, reactive, onMounted, watch } from "vue";
import { Request } from "@/api/request";
import {column} from "@/assets/types/common";
import {incomeListByDay} from "@/api/http";
import {useRouter} from "vue-router";
// import FilterIncomeList from "@/components/reconciliationList/FilterIncomeList.vue";

const listColumns: Array<column> = [
  {
    prop: "name",
    label: "收入日期",
    width: 120,
  },
  {
    prop: "sale_number",
    label: "收入类型",
    width: 80,
  },
  {
    prop: "sale_price",
    label: "关联单据",
    width: 80,
  },
  {
    prop: "total_price",
    label: "创建时间",
    width: 80,
  },
  {
    prop: "name",
    label: "状态",
    width: 120,
  },
  {
    prop: "sale_number",
    label: "金额",
    width: 80,
  },
  {
    prop: "sale_price",
    label: "收款方式",
    width: 80,
  },
  {
    prop: "total_price",
    label: "付款方",
    width: 80,
  },
  {
    prop: "name",
    label: "经手人",
    width: 120,
  },
  {
    prop: "sale_number",
    label: "备注",
    width: 80,
  },
  {
    prop: "sale_price",
    label: "操作",
    width: 80,
  }
];

export default defineComponent({
    name: "reconciliationList",
    // components: { FilterIncomeList },
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["营业对账"]);
        const headClass = inject("headClass");
        const Router = useRouter();
        let total = ref(0),
            loading = ref(false),
            totalData = reactive({
              columnList:[],
              tableData:[],
            }),
            listData = reactive({
              listTableData:[],
              listDia_show:false,
              listColumns,
            }),
            detailData = reactive({

            }),
            getFirstNowLastDay = ():number => {
              let now = new Date();
              let strLink = "-";
              let year = now.getFullYear();
              let month:any = now.getMonth() + 1;
              let day:any = now.getDate();
              if (month >= 1 && month <= 9) {
                month = "0" + month;
              }
              if (day >= 1 && day <= 9) {
                day = "0" + day;
              }
              let firstDate:string = year + strLink + month + strLink + '01';
              let currentDate = year + strLink + month;
              //var lastDay = this.getLastDay(year, month);
              //var lastDate = year + strLink + month + strLink + lastDay;
              return new Date(currentDate).getTime();
            },
            screenParameter = reactive( {
                page: 1,
                pagesize: 10,
                date_time: getFirstNowLastDay(),
            } as any),

            project = ref([]);

        let getTableData = () => {
                loading.value = true;
                Request.axiosInstance({
                    url: 'adminapi/Bookkeeping/reconciliationList',
                    data: {...screenParameter,date_time:screenParameter.date_time/1000}
                }).then((res: any) => {
                  totalData.columnList = res?.content?.column_list || [];
                  totalData.tableData = res?.content?.value_list || [];
                  loading.value = false;
                  total.value = res?.content?.total || 0;
                });
            },
            getListData = (pay_type:any,item:any) => {
            if (item[pay_type]<=0){
                return;
            }
                console.log(pay_type,item.time);
                Router.push({
                    path: '/cashRegister/reconciliationList/incomeListByDay',
                    query: {pay_type:pay_type,time:item.time}
                })
            },
            handleSizeChange = (value: number): void => {
                screenParameter.pagesize.value = value;
                getTableData();
            },
            handleCurrentChange = (pageSize: number): void => {
                screenParameter.page.value = pageSize;
                getTableData();
            },
            selectChange = (e: any): void => {

                getTableData();
            };

        onMounted(() => {
            getTableData();
        });

        return {
          headClass,
          total,
          loading,
          handleSizeChange,
          handleCurrentChange,
          selectChange,
          screenParameter,
          totalData,
          listData,
          detailData,
            getListData
        };
    }
});
